import React, { useState, useRef } from 'react';
import SpotifyPlayer from './SpotifyPlayer';

import '@fortawesome/fontawesome-free/css/all.min.css';
import './Jukebox.scss'

function Jukebox({accessToken, song}) {
    const [isPlayable, setIsPlayable] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isFlipped] = useState(false);
    const [started, setStarted] = useState(false);

    const playerRef = useRef();

    const handleRestart = () => {
        if (playerRef.current) {
            playerRef.current.restart();
            playerRef.current.resume();
            setStarted(true);
            setIsPlaying(true);
        } else {
            console.log("Restart: Player not ready yet.")
        }
    };

    const handlePlayPause = () => {
        if (playerRef.current) {
            if (isPlaying) {
                playerRef.current.pause();
                setIsPlaying(false);
            } else {
                if(!started) {
                    handleRestart();
                } else {
                    playerRef.current.resume();
                    setIsPlaying(true);
                }
            }
        } else {
            console.log("Play/Pause: Player not ready yet.")
        }
        setStarted(true);
    };

    return (
        <>
            <div className="vinyl-player-container">
                <div className={`vinyl-player ${isFlipped ? 'flipped' : ''}`}>
                    <div className="vinyl-player-side front">
                        <div className="logo"><img src="https://songsort.eu/SONGSORT.png" alt="SONGSORT Logo" className="w-24 sm:w-32 md:w-40 opacity-90"/></div>
                        <div className="invitation-text">
                            Wer singt? Welches Lied? Welcher Platz im Wettbewerb und woher kam die Person? Rate mal und gewinne!
                        </div>
                        <div className="turntable">
                            <div className="record-body"></div>
                            <div className={`disc ${isPlaying ? 'spinning' : ''}`}></div>
                            <div className="label"></div>
                            <div className={`needle ${isPlaying ? 'playing' : ''}`}></div>
                        </div>
                        <div className="controls">
                            <button id="play-pause-button" onClick={isPlayable && handlePlayPause} disabled={!isPlayable}>
                                <i className={`fas ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                                <SpotifyPlayer ref={playerRef}  accessToken={accessToken} trackUri={`spotify:track:${song.spotify}`} onPlayerReady={setIsPlayable} />
                            </button>
                            <button id="restart-button" onClick={isPlayable && handleRestart} disabled={!isPlayable}>
                                <i className="fas fa-redo-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Jukebox;
